function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1045-927H875v2043h-1920z"
}), React.createElement("path", {
  d: "M-1045-630H875v1701h-1920z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("path", {
  d: "M105.635 61.053c4.174 0 7.272 2.841 14.272 13.158h2.041A3.056 3.056 0 0 1 125 77.263v4.259a3.057 3.057 0 0 1-2.19 2.927l.734 21.089 1.221 1.22a3.737 3.737 0 0 1 0 5.28 3.708 3.708 0 0 1-2.64 1.093 3.709 3.709 0 0 1-2.639-1.093l-.184-.184c-3.837 1.04-9.016 1.68-13.667 1.68s-9.83-.64-13.667-1.68l-.184.184a3.708 3.708 0 0 1-2.64 1.093 3.709 3.709 0 0 1-2.64-1.093 3.737 3.737 0 0 1 0-5.28l1.222-1.22.733-21.089a3.057 3.057 0 0 1-2.19-2.927v-4.259a3.056 3.056 0 0 1 3.053-3.052h2.041c7-10.317 10.098-13.158 14.272-13.158zm16.313 14.833H89.322c-.76 0-1.377.618-1.377 1.377v4.259c0 .76.618 1.377 1.377 1.377h3.35a.837.837 0 1 1 0 1.675H90.13l-.743 21.352a.837.837 0 0 1-.245.563l-1.454 1.454a2.06 2.06 0 0 0 1.455 3.513c.55 0 1.067-.214 1.455-.602l.53-.53a.838.838 0 0 1 .825-.213c3.738 1.079 8.98 1.749 13.681 1.749 4.701 0 9.943-.67 13.681-1.75a.838.838 0 0 1 .824.213l.53.53c.39.39.906.603 1.456.603.55 0 1.066-.214 1.455-.602a2.06 2.06 0 0 0 0-2.911l-1.454-1.454a.837.837 0 0 1-.245-.563l-.743-21.352H96.022a.837.837 0 1 1 0-1.675h25.926c.76 0 1.377-.618 1.377-1.377v-4.259c0-.759-.617-1.377-1.377-1.377zm-16.313-13.158c-3.367 0-6.094 2.509-12.245 11.483h24.49c-6.151-8.974-8.878-11.483-12.245-11.483zm6.142 8.01a.894.894 0 0 1 0 1.787.894.894 0 0 1 0-1.786zm-11.167-.893a.894.894 0 0 1 0 1.787.894.894 0 0 1 0-1.787zm8.933-2.456a.894.894 0 0 1 0 1.786.894.894 0 0 1 0-1.786z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 56.144,
  y: 138.719
}, "Przetw\xF3rstwo"), React.createElement("tspan", {
  x: 27.936,
  y: 158.719
}, "produkt\xF3w ubocznych")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/produkty uboczne.6f0b6749.svg";
export { SvgComponent as ReactComponent };